import React, {useCallback, useEffect, useState} from "react";
import {Box, Grid, Paper, Button} from "@mui/material";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import keycloak from "../Keycloak";
import Filters from "../components/HR/Filters";
import TableTemplate from '../components/HR/TableTemplate';
import {getCandidatesByCompanyId, getJobsByCompanyId, getSelectedJobsByCompanyId} from "../utilities/HrAPI";
import {getAllClients} from "../utilities/ClientApi";
import {useClient} from "../utilities/ClientProvider";
import "./home.css";
import Loader from "./loader";

const Home = () => {
    const {client} = useClient();
    const [jobsOpen, setJobsOpen] = useState([]);
    const [loading, setLoading] = useState(true);
    const [businessName, setBusinessName] = useState('');
    const [clients, setClients] = useState([]);

    const getAllJobsAndUpdateUI = useCallback(async () => {
        if (!keycloak) return;

        setLoading(true);
        try {
            const [jobs, candidates, clientInfo] = await Promise.all([
                getJobsByCompanyId(keycloak.token),
                getCandidatesByCompanyId(keycloak.token),
                getAllClients(keycloak.token),
            ]);

            setClients(clientInfo);

            const candidatesCount = candidates?.reduce((acc, candidate) => {
                acc[candidate.jobHash] = (acc[candidate.jobHash] || 0) + 1;
                return acc;
            }, {}) || {};

            const clientId = sessionStorage.getItem("selected_client_id") || client;
            const updatedJobs = (clientId !== "all" && businessName)
                ? await getSelectedJobsByCompanyId(client, keycloak.token)
                : jobs;

            const jobsWithCandidates = updatedJobs.map(job => ({
                ...job,
                candidates: candidatesCount[job.hashedCode] || 0,
            }));

            setJobsOpen(jobsWithCandidates);
        } catch (e) {
            console.error('Failed to fetch jobs:', e);
        } finally {
            setLoading(false); // Set loading to false once done
        }
    }, [businessName, client]);

    useEffect(() => {
        const sessionClient = sessionStorage.getItem("selected_client_id");
        const clientId = sessionClient ? parseInt(sessionClient) : client;
        const selectedClient = clients?.find(item => item.clientId === clientId) || {};
        setBusinessName(selectedClient ? selectedClient.businessName : '');
    }, [client, clients]);

    useEffect(() => {
        getAllJobsAndUpdateUI();
    }, [getAllJobsAndUpdateUI]);

    const filterNames = ["All", "Development", "Design", "Analysis", "Testing", "Admin"];
    const [selectedFilter, setSelectedFilter] = useState(0);

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
    };

    const columns = [
        {id: 'jobTitle', label: 'Job title', minWidth: 150},
        {id: 'dateModified', label: 'Date modified', minWidth: 150},
        {id: 'candidates', label: 'Candidates', minWidth: 150},
        {id: 'viewButton', label: '', minWidth: 100},
    ];

    if (loading) {
        return (
            <Box data-testid='hrDashboard'>
                <Loader/>
            </Box>
        );
    }

    return (
        <div style={{width: '90%', margin: '20px auto 2%'}}
             className={keycloak.hasResourceRole("hr_admin") || keycloak.hasResourceRole("client_recruiter") ? "d-flex" : "d-none"}
             data-testid='hrDashboard'>
            <Grid container direction="row" data-testid='hrDashboardHeaderDiv' style={{marginBottom: "10px"}}>
                <Grid item xs={12}>
                    <Box>
                        <h1 style={{marginBottom: "15px"}}>{!jobsOpen.length ? "Welcome to TonicHub" : "Dashboard"}</h1>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    {!jobsOpen.length ? (
                        <Box xs={12} className="box">
                            <Paper className="paper">
                                <Grid container direction='column' spacing={2} justifyContent='center'
                                      alignItems='center' className="p-3">
                                    <Grid item>
                                        <BusinessCenterIcon className="icon"/>
                                    </Grid>
                                    <Grid item>
                                        <h3>Create Job position</h3>
                                    </Grid>
                                    <Grid item>
                                        <Button className="button" href="/JobsAdd">
                                            Create Job
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>
                    ) : (
                        <div>
                            <Filters filterNames={filterNames} onFilterChange={handleFilterChange}
                                     selectedFilter={selectedFilter}/>
                            <TableTemplate columnsArray={columns} data={jobsOpen} search={false}
                                           filter={filterNames[selectedFilter]}/>
                        </div>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}

export default Home;
